<template>
  <div class="btn-group dropdown-default btn-block pg-dropdown" pg-dropdown> 
    <a class="btn btn-block dropdown-toggle" data-toggle="dropdown" href="">
      {{ selected && selected[labelProperty] ? selected[labelProperty] : 'Select' }} <span class="caret"></span>
    </a>
    <ul class="dropdown-menu">
      <li v-for="item in items"><a @click.prevent="select(item)" href="#">{{ item[labelProperty] }}</a></li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'PagesDropdown',
    props: {
      items: {
        type: Array,
        default: () => []
      },
      labelProperty: {
        type: String,
        default: 'title'
      },
      selected: {
        type: Object,
        default: () => ({})
      },
      onChange: {
        type: Function,
        default: (item) => {}
      }
    },    
    methods: {
      select(item) {
        // emit only real change
        console.log('selected', item[this.labelProperty]);
        if (typeof this.selected === 'object' && item[this.labelProperty] !== this.selected[this.labelProperty]) {
          this.onChange(item);
          console.log('onChange called');
        }
      }
    }
  }
</script>

<style>
  .pg-dropdown {
    height: 35px;
  }

  th .pg-dropdown a.btn.dropdown-toggle {
    margin-top: 0;
  }
</style>


// WEBPACK FOOTER //
// dropdown.vue?fbae3d66